import { render, staticRenderFns } from "./PlcExcelTable.vue?vue&type=template&id=27a319c8&scoped=true"
import script from "./PlcExcelTable.vue?vue&type=script&lang=js"
export * from "./PlcExcelTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a319c8",
  null
  
)

export default component.exports